/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TravelineChildrenServiceCountDto
 */
export interface TravelineChildrenServiceCountDto {
    /**
     * Child age
     * @type {number}
     * @memberof TravelineChildrenServiceCountDto
     */
    age?: number;
    /**
     * Number of extra services provided to children depending on their age
     * @type {number}
     * @memberof TravelineChildrenServiceCountDto
     */
    count?: number;
}

/**
 * Check if a given object implements the TravelineChildrenServiceCountDto interface.
 */
export function instanceOfTravelineChildrenServiceCountDto(value: object): value is TravelineChildrenServiceCountDto {
    return true;
}

export function TravelineChildrenServiceCountDtoFromJSON(json: any): TravelineChildrenServiceCountDto {
    return TravelineChildrenServiceCountDtoFromJSONTyped(json, false);
}

export function TravelineChildrenServiceCountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineChildrenServiceCountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'age': json['age'] == null ? undefined : json['age'],
        'count': json['count'] == null ? undefined : json['count'],
    };
}

  export function TravelineChildrenServiceCountDtoToJSON(json: any): TravelineChildrenServiceCountDto {
      return TravelineChildrenServiceCountDtoToJSONTyped(json, false);
  }

  export function TravelineChildrenServiceCountDtoToJSONTyped(value?: TravelineChildrenServiceCountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'age': value['age'],
        'count': value['count'],
    };
}

